import React, { FC } from "react";

import { Icon, Typography } from "ui-library/atoms";
import { Box, Flexbox } from "ui-library/layouts";

export interface InfoMessageProps {
    message: string;
}

export const InfoMessage: FC<InfoMessageProps> = ({ message }) => (
    <Flexbox mb={2}>
        <Box mt={0.2} mr={0.7}>
            <Icon className="tooltip" size={16} icon="circle-info" color="blue" />
        </Box>
        <Typography markDown={message} />
    </Flexbox>
);
